"use client";

import { useRouter } from "next/navigation";
import { useState, useEffect } from "react";

const TermsandConditions = () => {
  const router = useRouter();
  const [isIndianUser, setIsIndianUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectUserLocation = () => {
      try {
        // Get user's timezone
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Indian timezones
        const indianTimezones = ["Asia/Kolkata", "Asia/Calcutta"];

        // Check if user is in Indian timezone
        const isIndian = indianTimezones.includes(timezone);
        setIsIndianUser(isIndian);
      } catch (error) {
        console.error("Error detecting timezone:", error);
        setIsIndianUser(false);
      } finally {
        setLoading(false);
      }
    };

    // Always detect location on component mount (every reload)
    detectUserLocation();
  }, []);

  const getIntroductionContent = () => {
    if (isIndianUser) {
      return (
        <p className="text-sm md:text-base">
          This website under the name and style &quot;GrowthSchool&quot; and
          available at (www.growthschool.io), is owned, operated, and made
          available by Sisinty Private Limited, with its registered office
          situated at C/O Sisinty Hari Prasad, Prem Nagar, 7th Line, Last House,
          Berhampur, Odisha, 760001 and includes any of our affiliates,
          associates, assignees or successors-in-interest as determined by us at
          our sole discretion and without requiring any prior notice or
          intimation (&quot;Company&quot;, &quot;we&quot; or &quot;us&quot; or
          &quot;our&quot;) to the person accessing, viewing or using the Website
          (&quot;You&quot; or &quot;Your&quot; or &quot;User&quot;).
        </p>
      );
    } else {
      return (
        <p className="text-sm md:text-base">
          This website under the name and style &quot;GrowthSchool&quot; and
          available at (www.growthschool.io), is owned, operated, and made
          available by Sisinty Singapore Private Limited,, with its registered
          office situated at 151 CHIN SWEE ROAD #07-12, MANHATTAN HOUSE, 169876
          and includes any of our affiliates, associates, assignees or
          successors-in-interest as determined by us at our sole discretion and
          without requiring any prior notice or intimation (&quot;Company&quot;,
          &quot;we&quot; or &quot;us&quot; or &quot;our&quot;) to the person
          accessing, viewing or using the Website (&quot;You&quot; or
          &quot;Your&quot; or &quot;User&quot;).
        </p>
      );
    }
  };

  return (
    <div className="w-full mt-30">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="mb-6 flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            className="cursor-pointer"
            onClick={() => router.push("/")}
          >
            <path
              d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z"
              fill="#686C7A"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
          >
            <path
              opacity="0.6"
              d="M1 0.5L5 4.5L1 8.5"
              stroke="#686C7A"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <a
            href="#"
            title="Terms and Conditions"
            className="text-sm font-normal"
          >
            Terms and Conditions
          </a>
        </div>

        <div>
          <div>
            <h1 className="text-2xl md:text-3xl">Terms and Conditions</h1>
            <br />
            <p className="text-sm font-medium">Last Updated on 10th Feb 2025</p>
            <br />
          </div>

          <div className="privacy_policy">
            <div className="">
              <h2 className="text-base md:text-xl font-medium mb-3">
                Introduction
              </h2>
              {loading ? (
                <div className="animate-pulse">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                </div>
              ) : (
                getIntroductionContent()
              )}
              <br />

              <p className="text-sm md:text-base">
                Please read these terms and conditions (“Terms and Conditions”),
                along with the Company’s privacy policy available at Privacy
                Policy and all other rules and policies made available or
                published on the Website as they shall govern Your use of the
                Website and the Services (defined below) provided thereunder.
              </p>
              <br />

              <p className="text-sm md:text-base">
                Please note that You must be at least 18 (eighteen) years old to
                access, register on the Website and avail the Services. In case
                You represent an entity or an Institution (defined below), You
                hereby confirm that You have been duly authorized by such entity
                or Institution and further confirm that You are 18 (eighteen)
                years old or above and that You have the authority and all
                necessary approvals to enter into these Terms and Conditions and
                the Privacy Policy. If You are a Child, You are not permitted to
                access or register on this Website unless such access and
                registration is completed by a parent or legal guardian or the
                Instructor (defined below) as applicable. We may, in our sole
                discretion, refuse to offer the Service (defined below) to any
                person or entity and change the eligibility criteria at any
                time. Anyone below 18 (eighteen) years of age is assumed to be a
                child (“Child”) and requires parental consent to use the
                Website. The parents/legal guardian of the Child or users above
                18 (eighteen) years of age are hereinafter referred to as “You”
                or “Your”.
              </p>
              <br />

              <div className="text-sm md:text-base">
                <p>
                  {" "}
                  The Website’s privacy practices regarding the collection, use
                  and safeguard of Your information including any personal and
                  sensitive personal information shall be governed by the
                  Company’s Privacy Policy.
                </p>
                <br />
                <p>
                  By using or visiting the Website, You confirm Your agreement
                  to these Terms and Conditions and the Privacy Policy.
                </p>
                <br />
                <p>
                  These Terms and Conditions are an electronic record as per the
                  Information Technology Act, 2000 (as amended / re-enacted) and
                  rules thereunder and is published in accordance with the
                  provisions of Rule 3 (1)(b) of the of the Information
                  Technology (Intermediaries Guidelines and Digital Media Ethics
                  Code) Rules, 2021, which mandates for publishing of rules and
                  regulations, privacy policy and terms and conditions for
                  access or usage of any application or website. This electronic
                  record is generated by a computer system.
                </p>
                <br />

                <br />
              </div>

              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-3">
                Acceptance of Terms
              </h2>

              <p className="text-sm md:text-base">
                These Terms and Conditions are an electronic record as per the
                Information Technology Act, 2000 (as amended / re-enacted) and
                rules thereunder and is published in accordance with the
                provisions of Rule 3 (1)(b) of the of the Information Technology
                (Intermediaries Guidelines and Digital Media Ethics Code) Rules,
                2021, which mandates for publishing of rules and regulations,
                privacy policy and terms and conditions for access or usage of
                any application or website. This electronic record is generated
                by a computer system.
              </p>
              <br />

              <br />

              <h2 className="text-base md:text-xl font-medium mb-3">
                Overview of the Services
              </h2>
              <p className="text-sm md:text-base">
                We as an intermediary make available certain features and tools
                that enable the Instructors to interact, work with and mentor
                the Students (defined below) through various digital learning
                solutions such as video conferencing in order to provide such
                Students with tutorial, educational and other education-related
                services (“Services”). The Website is a platform through which
                You can obtain information about us and our Services. You may
                use the Website to subscribe to the Services in accordance with
                the Terms and Conditions and the Privacy Policy.
              </p>
              <br />

              <p className="text-sm md:text-base">
                The Website allows teachers, mentors and instructors to
                subscribe to our Services which further enables them to share,
                access, and provide various educational content including
                sessions, classes, lectures and webinars (“Instructors”) to
                various students across the globe who have subscribed to our
                Services to receive such educational content (“Students”).
              </p>
              <br />

              <p className="text-sm md:text-base">
                As part of the Services, we also enable users of the Website to
                access various Company Materials (defined below) as may be
                provided by us on the Website from time to time. These Terms and
                Conditions apply to all Your and/or Your Child’s activities on
                the Website, our mobile application, other related services and
                platform as communicated to You by us from time to time.
              </p>
              <br />

              <p className="text-sm md:text-base">
                Please note that we only act as an intermediary between the
                Instructors and the Students for the provision of Services. Any
                services provided by the Instructors shall be provided on an “as
                is” basis and we shall not be made responsible and/or liable for
                any performance and obligation of the Instructors including any
                warranty for the services being provided by such Instructors.
              </p>
              <br />

              <p className="text-sm md:text-base">
                Additionally, as part of the Services, there are currently
                educational courses on various subjects offered by us, and
                depending upon the course module selected by You, we grant You
                access to the course module’s material, content, curriculum,
                documents and other information and data (“Company Material”)
                which may be in the form of video, audio, written, graphic,
                recorded, photographic, or any other format as may be prescribed
                and provided by us. Upon availing of the Services, we grant You
                a limited, non-transferable, non-exclusive and revocable license
                to access, view and use the Website, the Services and the
                Company Material for non-commercial purposes only. Any rights
                not expressly granted to You herein are reserved by the Company.
                You shall abide by and maintain all copyright notices,
                information, and restrictions contained in any such Company
                Material. It is hereby clarified that such Company Material is
                provided by third parties and that the Company does not monitor,
                curate, edit or has any control over such Company Material. All
                Company Material is made available on an “as is” and “as
                available” basis and without any representations or warranties
                whatsoever, and the Company hereby disclaims any implied
                warranties, including but not limited to warranties of fitness
                for use, accuracy, merchantability, and non-infringement.
              </p>
              <br />

              <p className="text-sm md:text-base">
                It is further clarified that access to the Services under this
                Clause is for a limited period of time as communicated by us on
                the Website from time to time and any payment of Fees (defined
                below) under Clause 7 does not entitle You or Your Child to
                unlimited access to the Services and/or the Company Materials.
              </p>
              <br />

              <h2 className="text-base md:text-xl font-medium mb-3">Access</h2>

              <p className="text-sm md:text-base">
                Subject to these Terms and Conditions and the Privacy Policy, we
                offer to provide the Services, which are selected by You, solely
                for Your benefit, and not for the use or benefit of any third
                party.
              </p>
              <br />

              <p className="text-sm md:text-base">
                If there is any particular content You wish to procure from the
                Website pertaining to any Service, You may be required to send
                us an email from Your registered email-id, requesting us for
                access to such content. You agree and acknowledge that grant of
                any such request shall be at the sole discretion of the Company.
              </p>
              <br />

              <h2 className="text-base md:text-xl font-medium mb-3">
                Registration and Eligibility
              </h2>

              <p className="text-sm md:text-base">
                In order to use and avail the Services, You are required to
                register with us by providing personal information relating to
                You and/or the Child, and covenant that You shall provide us
                with accurate, correct and complete registration information
                including but not limited to, (i) Your and/or the Child’s name,
                (ii) Your e-mail ID, (iii) Your contact details (iv) payment
                information of the Fees for the Services, if required and (v)
                any other documents as required under applicable laws and
                communicated to You on the Website from time to time. You shall
                follow the registration process as communicated to You on the
                Website from time to time. You shall ensure that the requisite
                information provided by You to us for the Services, is
                absolutely true, up-to-date and correct and nothing material has
                been concealed, and that You agree to maintain the accuracy of
                such information. We will not be liable for any incident
                occurring due to incorrect or insufficient information provided
                by You.
              </p>
              <br />

              <p className="text-sm md:text-base">
                You acknowledge that Your user ID and password for the Website
                (“Login Details”) is for Your exclusive use only. You are solely
                responsible and liable for any activity that occurs on Your
                account and You shall not use or share Your Login Details with
                another user or person. It is hereby clarified that any
                contravention of this Clause is cause for immediate suspension
                of Your access to the Website, the Services and the content
                including Company Materials provided by us. You agree to
                immediately notify and update us in the event there is any
                change in Your Login Details and further covenant to keep us
                updated at all times.
              </p>
              <br />

              <p className="text-sm md:text-base">
                You are solely responsible for maintaining the confidentiality
                of Your Login Details and for all activities that occur under
                it. You agree to immediately notify us if You become aware of or
                have reason to believe that there is any unauthorized use of
                Your Login Details. You also agree to take all necessary steps
                to stop such unauthorized use and to cooperate with us in any
                investigation of such unauthorized use. We shall not under any
                circumstances be held liable for any claims related to the use
                or misuse of Your Login Details due to the activities of any
                third party outside of our control or due to Your failure to
                maintain the confidentiality and security of Your Login Details.
              </p>
              <br />

              <p className="text-sm md:text-base">
                Registration as a user is only a one-time process and if You
                have been previously registered, You shall login / sign into
                Your account using the existing Login Details
              </p>
              <br />

              <p className="text-sm md:text-base">
                Notwithstanding anything contained herein, You shall not:
              </p>
              <br />

              <p className="text-sm md:text-base">
                provide any false personal information to us (including a
                false/fraudulent Login Details) or create any account for anyone
                other than Yourself without such person&apos;s explicit
                permission;
              </p>
              <br />

              <p className="text-sm md:text-base">
                use the Login Details that is the name of another person with
                the intent to impersonate that person;
              </p>
              <br />

              <p className="text-sm md:text-base">
                use the Login Details that is subject to any rights of a person
                other than You without appropriate authorization; or
              </p>
              <br />

              <p className="text-sm md:text-base">
                use/generate the Login Details that may be, in our sole opinion,
                offensive, vulgar, obscene or otherwise unlawful.
              </p>
              <br />

              <p className="text-sm md:text-base">
                The subscription of the Services is not transferable, i.e., only
                the person or entity on whose name the subscription is made will
                be eligible to avail the Services.
              </p>
              <br />

              <h2 className="text-base md:text-xl font-medium mb-3">
                Instructors
              </h2>

              <p className="text-sm md:text-base">
                As an Instructor, You are responsible for all content that You
                post, including lectures, quizzes, coding exercises, practice
                tests, assignments, resources, answers, course landing page
                content, labs, assessments, and announcements (“Instructor
                Content”). Notwithstanding the above, the Company does not
                monitor or edit the Instructor Content provided by the
                Instructors. The Company may decline to accept and/or remove any
                Instructor Content that contain any information inconsistent
                with the Terms and Conditions and the Privacy Policy. Any
                Instructor Content uploaded /added by the Instructors shall be
                subject to applicable laws and these Terms and Conditions and
                the Privacy Policy and may be disabled, or may be subject to
                investigation under applicable laws. The Instructor shall abide
                by and maintain all copyright notices, information, and
                restrictions contained in any such Instructor Content accessed
                by the Students. You agree and acknowledge that we shall assume
                no liability for the quality and standard of such Instructor
                Content and shall not represent and warrant that such Instructor
                Content shall not be infringing any third-party intellectual
                property and/or applicable laws.
              </p>
              <br />

              <p className="text-sm md:text-base">
                All Instructor Content, whether publicly posted or privately
                transmitted, shall be the sole responsibility of the Instructor
                who originated such Instructor Content. We cannot guarantee the
                authenticity of any such Instructor Content. You acknowledge and
                agree that (i) all Instructor Content accessed by You, while
                utilizing or using the Services shall be at Your own risk and
                You will be solely responsible and liable for any damage or loss
                that may occur as may be attributable to You or any other party
                resulting therefrom; and (ii) we shall have no liability towards
                You or any such party for any damage or loss resulting from such
                Instructor Content. Instructors shall be responsible and liable
                for displaying of authentic Instructor Content while using the
                Services and we shall have no liability in this regard.
              </p>
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-3">Payment</h2>
              <div className="information_collected">
                <p>
                  The Services are made available to You on a subscription
                  basis. The fees for subscription to the Services availed by
                  You and/or Your Child shall be calculated as per the terms set
                  out below, payable during the subscription of the Services
                  (“Fees”):
                </p>
                <br />
                <p>
                  For Students: Students are required to pay a fixed
                  subscription Fee for the Services, rates of which shall be
                  intimated to the Students on the Website from time to time.
                  Additionally, purchases of any Company Material or availing of
                  self-evaluation tests shall be subject to additional charges
                  as communicated by us on the Website from time to time.
                </p>
                <br />
                <p>
                  For Instructors: Access to the Services shall be subject to a
                  subscription Fee which shall be paid on a per-Student basis.
                  Additional charges shall be applicable for any additional
                  Services on the Website including but not limited to access to
                  the Company Materials and/or conducting any online examination
                  on the Website.
                </p>
                <br />
                <p>
                  Please note that the Fees for the relevant Services under this
                  Clause shall be communicated by us on the Website from to time
                  and shall be valid until the completion of the period of your
                  selected Service or until cancelled or terminated in
                  accordance with these Terms and Conditions and Privacy Policy.
                </p>
                <br />
                <p>
                  At present, we charge for the Services in INR (Indian Rupees)
                  and in USD (United States Dollars). You explicitly agree to
                  pay the Fees for the Services that You or Your Child avail and
                  the Company Materials that You or Your Child access on the
                  Website. All payment of Fees shall be through the payment
                  mechanism put in place by the Company on the Website and You
                  shall be responsible for paying all Fees and applicable taxes
                  in a timely manner as per the mechanism associated with the
                  Service availed by You or Your Child. The payment terms under
                  this Clause are subject to a periodic review and revisions at
                  our sole discretion. We may modify and revise the payment
                  terms under this Clause and such modifications and revisions
                  may be intimated to You as and when required. Please note that
                  Your network operator may also separately charge You for data
                  and other usage.
                </p>
                <br />
                <p>
                  All payment of Fees made towards obtaining the subscription
                  for the Services shall be made directly to us via the channels
                  provided to You and shall not be made to the Instructors
                  directly at any point of time. We shall not be liable for any
                  amount advanced or paid by You in contravention to this. It is
                  hereby clarified that we shall assume no control over any
                  relationship, financial or otherwise between the Instructors
                  and the Students outside the purview of the Services, Website,
                  the Terms and Conditions and/or the Privacy Policy. We reserve
                  the right to delete or suspend Your or Your Child’s access to
                  Services for incomplete payment of Fees and any applicable
                  charges.
                </p>
                <br />
                <p>
                  While making payments though the payment gateways set up by
                  us, You hereby agree to be governed and bound by the terms and
                  conditions of the third-party payment gateway service
                  providers, including any convenience fee levied by such
                  service provider.
                </p>
                <br />
                <p>
                  While availing any of the payment methods made available
                  through the Services, we will not be responsible or assume any
                  liability, whatsoever in respect of any loss or damage arising
                  directly or indirectly to You due to:
                </p>
                <br />
                <p>lack of authorization for any transaction/s; or</p>
                <br />
                <p>
                  exceeding of the pre-set limit mutually agreed between You and
                  the financial services providers You deal with; or
                </p>
                <br />
                <p>any payment issues arising out of the transaction.</p>
                <br />
                <br />
              </div>
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-3">
                Refunds and Cancellations
              </h2>

              <p>
                You may be eligible for refunds for any payment of Fees made for
                Services in accordance with the refund policy available on the
                Refund Policy Website.
              </p>
              <br />
              <br />
            </div>

            <div className="policy_item">
              <div className="sharing_inf">
                <div className="sharing_inf_item">
                  <h2 className="text-base md:text-xl font-medium mb-3">
                    Conditions To Use
                  </h2>
                  <p>
                    We will make reasonable efforts to ensure that You are able
                    to use the Services without undue disruption, interruption
                    or delay. You agree and acknowledge that we are merely
                    acting as an intermediary and our role is limited to
                    providing an online platform to facilitate the Services.
                  </p>
                  <br />
                  <p>
                    Once You create an account on the Website, You may receive
                    updates, promotional materials and other information we may
                    send, including through email and WhatsApp, with regards to
                    the Services, or new services we may offer. You may opt out
                    of receiving any, or all, of these commercial communications
                    from us by raising a support request as provided for on the
                    Website or following the instructions provided in any email
                    and/or text we send. However, You will continue to receive
                    important updates with respect to Your account on the
                    Website
                  </p>
                  <br />
                  <p>
                    When You avail the Services, You agree that You are involved
                    in the transmission of sensitive and personal information,
                    especially information related to Your Child. You agree and
                    consent to us collecting, using, storing and processing the
                    above stated information, in accordance with our Privacy
                    Policy read along with these Terms and Conditions.
                  </p>
                  <br />
                  <br />
                </div>

                <div className="sharing_inf_item">
                  <h2 className="text-base md:text-xl font-medium mb-3">
                    Intellectual Property
                  </h2>
                  <p>
                    All trademarks, information, content, marks, texts, video,
                    software and material (including the Company Material) on
                    the Website and Services are the intellectual property of
                    the Company. You covenant not to reproduce whether in whole
                    or partly of the aforementioned intellectual property of the
                    Company, except with the prior written consent of the
                    Company. You undertake to use the Services and the Company’s
                    intellectual property only for the purposes specified in
                    these Terms and Conditions.
                  </p>
                  <br />
                  <p>
                    We may make available on the Services, certain Company
                    Materials that are owned by us or our third-party licensors.
                    We grant You and/or Your Child a non-exclusive,
                    non-transferable right to access and use the Company
                    Materials as made available on the Website by us solely for
                    Your personal and non-commercial purposes. Unless expressly
                    indicated on the Services that a particular item of the
                    Company Material is made available to You under alternate
                    license terms, You or Your Child may not download,
                    distribute, sell, lease, modify, or otherwise provide access
                    to the Company Material to any third party.
                  </p>
                  <br />
                  <br />
                </div>

                <div className="sharing_inf_item">
                  <h2 className="text-base md:text-xl font-medium mb-3">
                    Rules and Conduct
                  </h2>
                  <p>
                    As a condition of use, You covenant not to use the Services
                    and the Company Materials for any purpose that is prohibited
                    by these Terms and Conditions, the Privacy Policy and by the
                    applicable laws in force. You are responsible for all of
                    Your activity in connection with the Services and the
                    Company Materials.
                  </p>
                  <br />
                  <p>
                    By way of examples, and not as a limitation, You shall not
                    take any action that: infringes any patent, trademark, trade
                    secret, copyright, right of publicity or other right of any
                    other person or entity or violates any law or contractual
                    duty or obligations of confidentiality, copies, rents,
                    leases, distributes, or otherwise transfers any of the
                    rights that You receive hereunder, modifies, adapts,
                    appropriates, reproduces, distributes, translates, creates
                    derivative works or adaptations of, publicly displays,
                    republishes, repurposes, sells, trades, or in any way
                    exploits the Service or the Company Material, except as
                    expressly authorized by us, deciphers, decompiles,
                    disassembles, reverse engineers or otherwise attempts to
                    derive any hardware, or source code or underlying ideas or
                    algorithms of any part of the Service or the Company
                    Materials (including without limitation any application or
                    widget), except to the limited extent applicable laws
                    specifically prohibiting such restriction, deletes or
                    modifies any content of the Services, including but not
                    limited to, legal notices, disclaimers or proprietary
                    notices such as copyright or trademark symbols, logos, that
                    You do not own or have express permission to modify;
                  </p>
                  <br />
                  <p>
                    As a condition of use, You covenant not to use the Services
                    and the Company Materials for any purpose that is prohibited
                    by these Terms and Conditions, the Privacy Policy and by the
                    applicable laws in force. You are responsible for all of
                    Your activity in connection with the Services and the
                    Company Materials.
                  </p>
                  <br />
                  <p>
                    You know is false, misleading, untruthful or inaccurate, is
                    unlawful, threatening, abusive, harassing, defamatory,
                    libelous, deceptive, fraudulent, invasive of another&apos;s
                    privacy, tortious, obscene, vulgar, pornographic, offensive,
                    profane, contains or depicts nudity, contains or depicts
                    sexual activity, promotes bigotry, discrimination or
                    violence, or is otherwise inappropriate as solely determined
                    by us in our sole discretion, malicious including but not
                    limited to making false or malicious statements against the
                    Services or us;
                  </p>
                  <br />
                  <p>
                    constitutes unauthorized or unsolicited advertising, junk or
                    bulk e-mail; involves sharing any link or data that contains
                    software viruses or any other computer codes, files, worms,
                    logic bombs or programs that are designed or intended to
                    disrupt, disable, damage, limit or interfere with the proper
                    functioning of any software, hardware, or telecommunications
                    equipment or to damage or obtain unauthorized access to any
                    of our system, data, password or other information or any
                    third party;
                  </p>
                  <br />
                  <p>
                    will impersonate any person or entity, including any of our
                    employee or representative, violates anyone&apos;s
                    identification documents or sensitive financial information,
                    uses the Services in any unlawful manner, for any unlawful
                    purpose, or in any manner inconsistent with these Terms and
                    Conditions, or is fraudulent or malicious, for example, by
                    hacking into or inserting malicious code, including viruses,
                    or harmful data, into any Services or any operating system;
                  </p>
                  <br />
                  <p>
                    interferes or attempts to interfere with the proper working
                    of the Service or any activities conducted on the Website,
                    bypasses any measures we may use to prevent or restrict
                    access to the Service (or other accounts, computer systems
                    or networks connected to the Service); or
                  </p>
                  <br />
                  <p>
                    breaches the Terms and Conditions and the Privacy Policy
                    and/or any of the other policies and rules incorporated
                    herein, or is in violation of our Company guidelines and
                    policies.
                  </p>
                  <br />
                  <p>
                    We reserve the right to access, read, preserve, and disclose
                    any information as we reasonably believe is necessary to (i)
                    satisfy any applicable law, regulation, legal process or
                    governmental request, (ii) enforce these Terms and
                    Conditions and the Privacy Policy, including investigation
                    of potential violations hereof, (iii) detect, prevent, or
                    otherwise address fraud, security or technical issues, (iv)
                    respond to user support requests, or (v) protect our rights,
                    property or safety of our users/ subscribers and the public.
                  </p>
                  <br />
                  <p>
                    Nothing contained herein shall be deemed to exclude or limit
                    your liability in respect of any indemnity given by you
                    under these Terms.
                    <br /> Without prejudice to the foregoing, none of the
                    directors, officers, employees, and agents of Growth School
                    shall be personally liable for any action in connection with
                    the Website or Services.
                  </p>
                  <br />
                  <br />
                </div>

                <div className="sharing_inf_item">
                  <h3 className="text-sm md:text-base font-medium mb-2">
                    Disclosure to Other Service Recipients
                  </h3>
                  <p>
                    You hereby permit the Company to disclose to disputants,
                    dispute resolution professionals, witnesses and legal
                    counsel <span>(&quot;Other Service Recipients&quot;)</span>{" "}
                    your Personal Information to the extent such disclosure is
                    required - (a) for you to avail the Services; or (b) by the
                    rules of the Company or any third party for resolution of
                    disputes on the Website; or (c) by applicable law.
                  </p>
                  <br />
                  <br />
                </div>

                <div className="sharing_inf_item">
                  <h2 className="text-base md:text-xl font-medium mb-3">
                    User Content
                  </h2>
                  <p>
                    Subject to the conditions of the Terms and Conditions and
                    the Privacy Policy, we provide You access to submit, post,
                    publish, or broadcast content on our Website so as to
                    provide feedback on the Services (“User Content”). You agree
                    that we reserve the right to remove any User Content at our
                    sole discretion.
                  </p>
                  <br />
                  <p>
                    Notwithstanding the above, the Company does not monitor or
                    edit the User Content provided by You. The Company may
                    decline to accept and/or remove any User Content that
                    contains any information inconsistent with the Terms and
                    Conditions and the Privacy Policy. Any User Content uploaded
                    by You shall be subject to applicable laws and these Terms
                    and Conditions and the Privacy Policy and may be disabled,
                    or may be subject to investigation under applicable laws.
                  </p>
                  <br />
                  <p>
                    Your Child may choose to write and post reviews on the
                    Website. We do not encourage Your Child to post any personal
                    information on the Website and the ill effects of such
                    revelation shall be borne by You. However, You may request
                    the Company via a support request to delete any such
                    information posted by the Child.
                  </p>
                  <br />
                  <p>
                    You shall not (and/or shall not permit Your Child to)
                    publish or undertake to publish any User Content which may
                    contain any of the following:
                  </p>
                  <br />
                  <p>
                    <strong>Offensive Content:</strong> Any User Content that is
                    or has the tendency to be unlawful, threatening, abusive,
                    harassing, defamatory, libellous, deceptive, fraudulent,
                    invasive of another’s privacy, obscene, vulgar,
                    pornographic, offensive, profane, contains or depicts nudity
                    or profane language, or sexual activity and any explicit
                    content with an intent to be sexually gratifying, promotes
                    bigotry, discrimination or violence against any race,
                    religion, caste, belief, ethnicity sexual orientation or
                    behaviour, gender, disability, health condition, criminal
                    record, political bias, creed or country, or is otherwise
                    inappropriate as determined by us in our sole discretion.
                    The User Content should also be compliant with all
                    applicable laws including but not limited to The Information
                    Technology Act, 2000, Indecent Representation of Women and
                    Children Act, 2008 and the Bharatiya Nyaya Sanhita, 2023
                    which prohibits reproduction of any content pertaining to
                    obscenity and indecent representation of women in India;
                  </p>
                  <br />
                  <p>
                    <strong>
                      Infringes Third Party Intellectual Property Rights:
                    </strong>{" "}
                    Any User Content that infringes or has the tendency or
                    threatens to infringe any intellectual property rights
                    including but not limited to patent, trademark, trade
                    secret, copyright, design, geographical indication, right of
                    publicity, privacy rights and/or any other rights of any
                    third person or any entity without any license or permission
                    of such party;
                  </p>
                  <br />
                  <p>
                    <strong>Fraudulent Information:</strong> Any User Content
                    that You know or have had knowledge of, to be fraudulent,
                    false, misleading, untruthful or inaccurate;
                  </p>
                  <br />
                  <p>
                    <strong>Impersonates a Third Party:</strong> Any User
                    Content that impersonates any third person or an entity,
                    including any of our or our affiliate’s employees or
                    representatives or personnel;
                  </p>
                  <br />
                  <p>
                    <strong>Compromises Cyber Safety:</strong> Any User Content
                    that contain, including but not limited to, any software
                    viruses or computer codes, files, worms, logic bombs or
                    programs that are designed and/or intended to disrupt,
                    disable, damage, limit or interfere with the proper
                    functioning of our Services or any software, hardware, or
                    telecommunications equipment or to damage or to obtain
                    unauthorized access to any system, data, password or any of
                    our other information;
                  </p>
                  <br />
                  <p>
                    <strong>Third Party Sensitive Personal Information:</strong>{" "}
                    Any User Content that includes or has the tendency to
                    include any third party sensitive personal information, as
                    defined under the applicable laws, without the prior express
                    consent of such concerned third party; or
                  </p>
                  <br />
                  <p>
                    <strong>Breaches Our Privacy Policy: </strong> Any User
                    Content that breaches or has the tendency to breach the
                    terms of our Privacy Policy.
                  </p>
                     <br />
                  <p>
                    <strong>Communications:</strong> You hereby expressly agree to receive
                    communication (including transactional messages) via SMS/RCS
                    (Rich Communication Services), email, and/or WhatsApp from
                    the Company in connection with the Services or your
                    registration on the Platform. We may also contact you
                    telephonically or through email to introduce new
                    product/service offerings. In case you do not wish to
                    receive such communication, you are requested to actively
                    opt out.
                  </p>
                  <br />
                  <p>
                    We will not be held responsible or liable for any of the
                    User Content provided by You or Your Child on the Website.
                  </p>
                  <br />
                  <br />
                </div>
              </div>
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2">
                Indemnity
              </h2>

              <br />
              <p>
                To the extent permitted by law, You agree to indemnify and keep
                indemnified, defend and hold the Company and its affiliates and
                its and their respective officers, directors, shareholders,
                employees, agents and representatives harmless from and against
                any and all losses and damages, including, but not limited to,
                any and all fines, penalties, liabilities and obligations
                (whether known or unknown, asserted or unasserted, absolute or
                contingent, accrued or unaccrued, matured or unmatured,
                determined or determinable, disputed or undisputed, liquidated
                or unliquidated, or due or to become due), including all
                reasonable fees, costs and expenses (including, without
                limitation, reasonable expenses of investigation and mediation
                and reasonable attorneys’, accountants’ and other professional
                fees) relating thereto including claims made by a third party
                arising out of (i) Your use of the Services; (ii) any breach of
                these Terms and Conditions by You; and (iii) violation of any
                applicable law by You.
              </p>
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Termination
              </h2>
              <br />
              <p>
                We may terminate Your access to all or any part of the Service
                at any time and/or deactivate Your account or limit Your access
                to the Website (a) if You breach any of the terms contained
                herein or in the Privacy Policy; (b) If Your use of the
                Services, in our reasonable opinion may result in a security
                issue; and (c) for any other reason we deem fit. If You wish to
                terminate Your account, You may do so by initiating a support
                request by sending us an email from Your registered email-id or
                through such other means as provided by us on the Website.
                Subject to Clause 8 herein, any Fees paid hereunder are
                non-refundable. All provisions of these Terms and Conditions
                which by their nature survive termination shall survive
                termination, including, without limitation, Intellectual
                Property (Clause 10), Indemnity (Clause 13), and Warranty
                Disclaimer And Limitation Of Liability (Clause 15).
              </p>
              <br />
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Warranty Disclaimer and Limitation of Liability
              </h2>
              <p>
                Save to the extent required by law, we are acting as an
                intermediary and we have no special relationship with or
                fiduciary duty to You. You acknowledge that we have no control
                over, and no duty to take any action regarding: what effects the
                Services may have on You and/or Your Child or how You and/or
                Your Child may interpret or benefit from the Services.
              </p>
              <br />
              <p>
                We are not liable for the information and the training provided
                by the Instructors on the Website and we do not guarantee or
                warrant to its accuracy, adequacy, correctness, validity,
                completeness, or suitability for any purpose, and accept no
                responsibility with respect to the information and coaching
                given by the Instructors on the Website
              </p>
              <br />
              <p>
                We do not undertake any review of the Company Material and the
                Instructor Content and the Company does always not guarantee the
                quality of lessons delivered to the Students or the Child. At
                any instance of live interactive classes, if the Instructor uses
                any sexual or abusive language or depicts any forced sexual
                acts, or pornographic images or does any unethical, unlawful or
                immoral act, then in such cases, please immediately inform us of
                such event. We may, at our sole discretion, make commercially
                reasonable efforts to take appropriate actions as per the
                applicable laws. However, we explicitly disclaim any liability
                or responsibility in the event of such a circumstance.
              </p>
              <br />
              <p>
                We will not be held responsible for any unethical, illegal acts
                performed by the Students or the Child on the advice of the
                Instructors and it shall be Your responsibility to closely
                monitor the activities of Your Child while accessing the
                Website.
              </p>
              <br />
              <p>
                You understand and acknowledge that Your subscription or use of
                the Services does not in any way guarantee the achievement of
                any specified percentage of marks in any examinations or passing
                of any examinations.
              </p>
              <br />
              <p>
                We do not undertake any review of the Company Material that are
                being provided on the Website, and such Company Material is
                being provided on an “as is” and “as available” basis and are
                provided without any representations or warranties of any kind,
                express or implied, including, but not limited to, the implied
                warranties of title, non-infringement, merchantability and
                fitness for a particular purpose, and any warranties implied by
                any course of performance or usage of trade, all of which are
                expressly disclaimed, save to the extent required by law.
              </p>
              <br />
              <p>
                You understand and acknowledge that Your subscription or use of
                the Services does not in any way guarantee the achievement of
                any specified percentage of marks in any examinations or passing
                of any examinations.
              </p>
              <br />
              <p>
                In no event shall we be liable for any direct, indirect,
                incidental, special or consequential damages, or damages for
                loss of profits, revenue, data or data use, incurred by You,
                whether in an action in contract or tort, arising from Your
                access to, or use of the Website or any content provided on or
                through the Website. Notwithstanding anything contained in the
                Terms and Conditions and the Privacy Policy, the Company’s
                maximum aggregate liability for any claim of direct and proven
                damages, shall not exceed the actual Fees paid by You to the
                Company for the Services availed by You in the previous 1 (one)
                month prior to the claim.
              </p>
              <br />
              <p>
                Nothing in these Terms and Conditions shall be deemed to exclude
                or limit Your liability in respect of any indemnity given by You
                under the Terms and Conditions. Applicable law may not allow the
                limitation or exclusion of liability or incidental or
                consequential damages, so the above limitation or exclusion may
                not apply to You. In such cases, our liability will be limited
                to the fullest extent permitted by applicable law.
              </p>
              <br />
              <p>
                We do not warrant that the operation of the Service will be
                uninterrupted or error-free. We will not be liable in any way
                for failure to perform any obligation under these Terms and
                Conditions, if such failure is caused by the occurrence of any
                unforeseen contingency beyond our reasonable control including
                but not limited to internet outages, communications outages,
                fire, flood, war, epidemics, pandemics or acts of God.
              </p>
              <br />
              <p>
                Instructors shall ensure compliance with all applicable laws
                while providing educational services on the Website, including
                having in full force and effect all licenses, permits and
                authorizations as it/they may be required to obtain from time to
                time for providing educational services and shall ensure that
                such licenses, permissions, authorizations, permits and consents
                are valid while accessing and utilizing our Services on the
                Website. It is hereby clarified that we shall not be liable for
                any non-compliance by the Instructors under this Clause.
              </p>
              <br />
              <p>
                In no event shall we be liable for any direct, indirect,
                incidental, special or consequential damages, or damages for
                loss of profits, revenue, data or data use, incurred by You,
                whether in an action in contract or tort, arising from Your
                access to, or use of the Website or any content provided on or
                through the Website. Notwithstanding anything contained in the
                Terms and Conditions and the Privacy Policy, the Company’s
                maximum aggregate liability for any claim of direct and proven
                damages, shall not exceed the actual Fees paid by You to the
                Company for the Services availed by You in the previous 1 (one)
                month prior to the claim.
              </p>
              <br />
              <p>
                Nothing in these Terms and Conditions shall be deemed to exclude
                or limit Your liability in respect of any indemnity given by You
                under the Terms and Conditions. Applicable law may not allow the
                limitation or exclusion of liability or incidental or
                consequential damages, so the above limitation or exclusion may
                not apply to You. In such cases, our liability will be limited
                to the fullest extent permitted by applicable law.
              </p>
              <br />
              <p>
                We do not warrant that the operation of the Service will be
                uninterrupted or error-free. We will not be liable in any way
                for failure to perform any obligation under these Terms and
                Conditions, if such failure is caused by the occurrence of any
                unforeseen contingency beyond our reasonable control including
                but not limited to internet outages, communications outages,
                fire, flood, war, epidemics, pandemics or acts of God.
              </p>
              <br />
              <p>
                Instructors shall ensure compliance with all applicable laws
                while providing educational services on the Website, including
                having in full force and effect all licenses, permits and
                authorizations as it/they may be required to obtain from time to
                time for providing educational services and shall ensure that
                such licenses, permissions, authorizations, permits and consents
                are valid while accessing and utilizing our Services on the
                Website. It is hereby clarified that we shall not be liable for
                any non-compliance by the Instructors under this Clause.
              </p>
              <br />
              <p>Further, we will not be liable or responsible for:</p>
              <br />
              <p>
                any failure to perform, or delay in performance of, any of our
                obligations under these Terms and Conditions or any financial
                loss that is caused due to the use of the Services;
              </p>
              <br />
              <p>
                the Services not meeting Your individual requirements or the
                Services containing defects or errors or deficiencies, as the
                Services has not been developed specifically for You. It is Your
                responsibility to ensure that You use and utilize the Services
                if the facilities and functions of the Services meet Your
                requirements;
              </p>
              <br />
              <p>
                any loss or damage caused by a distributed denial-of-service,
                viruses attack, or other technologically harmful material that
                may infect Your device, data or other proprietary material due
                to Your use of the Services; and
              </p>
              <br />
              <p>
                additionally, by utilizing the Services, You understand,
                acknowledge and agree that internet transmissions are never
                completely private or secure and that any message or information
                You send using our Services may be read or intercepted by
                others, even if there is a special notice that a particular
                transmission is encrypted.
              </p>
              <br />
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Governing Law
              </h2>
              <p>
                A printed version of these Terms and Conditions, Privacy Policy
                and of any notice given in electronic form shall be admissible
                in judicial or administrative proceedings based upon or relating
                to these Terms and Conditions and the Privacy Policy to the same
                extent and subject to the same conditions as other business
                documents and records originally generated and maintained in
                printed form.
              </p>
              <br />
              <h2 className="text-sm md:text-base font-medium mb-2 underline">
                Dispute Resolution:
              </h2>
              <br />
              <p>
                These Terms and Conditions along with the Privacy Policy shall
                be governed by and construed in accordance with the laws of
                India. For all purposes of these Terms and Conditions and the
                Privacy Policy, and subject to Clause 16.2.2, the Parties’
                consent to the exclusive jurisdiction of courts located in
                Bengaluru, Karnataka.
              </p>
              <br />
              <p>
                Any controversies, conflicts, disputes and/or differences
                between the parties shall thereafter be resolved by arbitration
                in Bengaluru, Karnataka in accordance with the Arbitration and
                Conciliation Act, 1996 for the time being in force, which rules
                are deemed to be incorporated by reference in this Clause. The
                tribunal shall consist of 1 (one) arbitrator mutually appointed
                by the parties. The language of the arbitration shall be
                English.
              </p>
              <br />
              <p>
                The parties shall keep the arbitration confidential and not
                disclose to any person, other than those necessary to the
                proceedings, any information, transcripts or award unless
                required to do so by law. The decision of the arbitrator shall
                be final and binding on all the parties hereto.
              </p>
              <br />
              <p>
                Use of the Service is not authorized in any jurisdiction that
                does not give effect to all provisions of these Terms and
                Conditions and Privacy Policy, including without limitation,
                this Clause.
              </p>
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Severability
              </h2>
              <p>
                If any provision of these Terms and Conditions and the Privacy
                Policy is found to be unenforceable or invalid, that provision
                will be limited or eliminated to the minimum extent necessary so
                that these Terms and Conditions and the Privacy Policy will
                otherwise remain in full force and effect and enforceable. The
                failure of either party to exercise, in any respect any right
                provided for herein shall not be deemed a waiver of any further
                rights hereunder. Waiver of compliance in any particular
                instance does not mean that we will waive compliance in the
                future. In order for any waiver of compliance with these Terms
                and Conditions and the Privacy Policy to be binding, we must
                provide You with written notice of such waiver through one of
                our authorized representatives.
              </p>
              <br />
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Modification of Terms and Conditions
              </h2>
              <p>
                We retain the unfettered right to display any advertisements on
                the Website. Further, the Website may include links to third
                party advertisements and other websites / applications, whose
                terms and privacy practices may differ from those of ours. You
                are advised to use Your discretion while visiting such
                websites/applications or while providing any personal
                information on such websites/ applications, or while purchasing
                of any products or services on such websites/applications.
              </p>
              <br />
              <p>
                The inclusion of a link does not imply any endorsement by us of
                such third-party website, the website’s provider, the
                information on the third-party website, or the quality of
                products or services provided on such websites. You hereby agree
                and acknowledge that any access of such websites / applications
                shall be at Your sole risk, and we shall not be liable for any
                losses sustained by You in this regard.
              </p>
              <br />
              <p>
                If You access or submit personal information to any of those
                websites, such access and information will be governed by the
                terms of use and privacy policies of such third-party websites
                and we disclaim all responsibility or liability with respect to
                the terms and policies of such websites. You are hereby advised
                to carefully read the terms and privacy policy of any website
                that You may visit.
              </p>
              <br />
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Miscellaneous
              </h2>
              <p>
                Unless otherwise specified in these Term and Conditions and the
                Privacy Policy, all notices hereunder will be in writing and
                will be deemed to have been duly given when received or when
                receipt is electronically confirmed, if transmitted by e-mail.
              </p>
              <br />
              <p>
                In respect of these Terms and Conditions and the Privacy Policy
                and Your use of these Services, nothing in these Terms and
                Conditions and the Privacy Policy shall be deemed to grant any
                rights or benefits to any person, other than us and You, or
                entitle any third party to enforce any provision hereof, and it
                is agreed that we do not intend that any provision of these
                Terms and Conditions and the Privacy Policy should be
                enforceable by a third party as per any applicable law.
              </p>
              <br />
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Contact
              </h2>
              <p>
                Should You have questions about these Terms and Conditions and
                the Privacy Policy or information collection, use and disclosure
                practices in relation to the Services, You may contact our
                Grievance Officer as per the details and manner prescribed in
                our Privacy Policy.
              </p>
              <br />
              <br />
            </div>

            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">
                Grievance Officer
              </h2>
              <div className="officer">
                <p>Name: S Chaitanya</p>
                <p>Email ID: grievance@growthschool.io</p>
                <p>Phone: 6360754645</p>
              </div>
              <br />
              <br />
            </div>

            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsandConditions;
